"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OperationName = void 0;
var OperationName;
(function (OperationName) {
    OperationName["CREATE_PLAN_AND_FETCH_PACKING_OPTIONS"] = "CREATE_PLAN_AND_FETCH_PACKING_OPTIONS";
    OperationName["SET_PACKING_INFO_AND_FETCH_PLACEMENT_OPTIONS"] = "SET_PACKING_INFO_AND_FETCH_PLACEMENT_OPTIONS";
    OperationName["GET_SHIPMENTS_AND_ITEMS"] = "GET_SHIPMENTS_AND_ITEMS";
    OperationName["GET_TRANSPORTATION_OPTIONS"] = "GET_TRANSPORTATION_OPTIONS";
    OperationName["GET_FLEXPORT_SHIPPING_ESTIMATES"] = "GET_FLEXPORT_SHIPPING_ESTIMATES";
    OperationName["CONFIRM_PLACEMENT_OPTION_AND_CREATE_ORDER"] = "CONFIRM_PLACEMENT_OPTION_AND_CREATE_ORDER";
})(OperationName || (exports.OperationName = OperationName = {}));
//# sourceMappingURL=OperationName.js.map